import { USER_ROLES } from '~/global/data/roles'

export const PAGES = {
  GET_START: {
    href: '/get-started',
    icon: 'flag',
    iconType: 'custom',
    label: 'get-started',
    activePathStartsWith: '/get-started',
    permissions: [USER_ROLES.ALL],
  },
  PERSONAL_PROFILE: {
    href: '/personal-profile/basic-info',
    icon: 'profile',
    iconType: 'custom',
    label: 'personal-profile',
    activePathStartsWith: '/personal-profile',
    permissions: [USER_ROLES.ALL],
  },
  STAFF: {
    href: '/staff/all',
    icon: 'staff',
    iconType: 'custom',
    label: 'staff',
    activePathStartsWith: '/staff',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.ACADEMY_MANAGER, USER_ROLES.TRAINING_MANAGER],
  },
  SCHOOL_PROFILE: {
    href: '/school-profile/basic',
    icon: 'school-profile',
    iconType: 'custom',
    label: 'school-profile',
    activePathStartsWith: '/school-profile',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.ACADEMY_MANAGER],
  },
  ACADEMY: {
    href: '/academy',
    icon: 'academy',
    iconType: 'custom',
    label: 'academy',
    activePathStartsWith: '/academy',
    permissions: [USER_ROLES.ALL],
  },
  PERFORMANCE: {
    href: '/performance/my-appraisal',
    icon: 'performance',
    iconType: 'custom',
    label: 'performance',
    activePathStartsWith: '/performance',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.PERFORMANCE_STAFF],
  },
  REFLECTION: {
    href: '/reflection',
    icon: 'reflection',
    iconType: 'custom',
    label: 'Reflection',
    activePathStartsWith: '/reflection',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.PERFORMANCE_STAFF],
  },
  COMMUNITY: {
    href: '/community',
    icon: 'community',
    iconType: 'custom',
    label: 'community',
    activePathStartsWith: '/community',
    permissions: [USER_ROLES.ALL],
  },
  TRAINING: {
    href: '/training',
    icon: 'training',
    iconType: 'custom',
    label: 'training',
    activePathStartsWith: '/training',
    permissions: [USER_ROLES.ACADEMY_MANAGER, USER_ROLES.TRAINING_MANAGER],
  },
  COURSE: {
    href: '/training/create-course',
    icon: 'academy',
    iconType: 'custom',
    label: 'course',
    activePathStartsWith: '/training',
    permissions: [USER_ROLES.ALL],
  },
  SETTING: {
    href: '/settings/permissions',
    icon: 'settings',
    iconType: 'custom',
    label: 'settings',
    activePathStartsWith: '/settings',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.ACADEMY_MANAGER, USER_ROLES.TRAINING_MANAGER],
  },
  REPORT: {
    href: '/report',
    icon: 'report',
    iconType: 'custom',
    label: 'reports',
    activePathStartsWith: '/report',
    permissions: [USER_ROLES.PERFORMANCE_MANAGER, USER_ROLES.ACADEMY_MANAGER, USER_ROLES.TRAINING_MANAGER],
  },
  ADMIN: {
    href: '/admin',
    icon: 'gauge',
    label: 'admin-dashboard',
    iconType: 'material-icon',
    activePathStartsWith: '/admin',
    permissions: [USER_ROLES.SUPER],
  },
}

export const BUSYBEES_SCHOOL = [
  78, 242, 315, 835, 1869, 2588, 1574, 300, 1444, 997, 1624, 698, 1587, 880, 591, 1351, 1464, 510, 1070, 918, 364, 1055,
  1075, 811, 912, 1043, 247, 1661, 1295, 1538, 1506, 584, 169, 461, 1185, 1855, 258, 1677, 798, 1063, 1723, 450, 1076,
  388, 339, 1456, 962, 1168, 378, 91, 305, 732, 1580, 2725, 1067, 1122, 1293, 1022, 614, 620, 1739, 79, 525, 322, 1491,
  738, 688, 802, 1510, 636, 838, 528, 1581, 189, 1108, 1188, 442, 2724, 1541, 605, 1550, 417, 547, 351, 420, 472, 1051,
  390, 1549, 308, 984, 1429, 98, 2759, 2763, 243, 469, 489, 837, 1068, 1569, 332, 2727, 2728, 1839, 1917, 2023, 1175,
  780, 228, 161, 920, 1655, 1354, 917, 921, 1137, 2205, 350, 624, 1301, 1302, 1303, 1299, 911, 315, 316, 675, 1184,
  2134, 1528,
]
